import CreateCalcAPI from "./CreateCalcAPI";
import UpdateCalcAPI from "./UpdateCalcAPI";
import SendMailAPI from "./SendMail";
import {VerifyCodeAPI} from "./VerifyCodeAPI";
import CloseCalcAPI from "./CloseCalcAPI";
import PaymentAPI from "./PaymentAPI";
import DashboardAPI from "./DashboardAPI";
import DateAPI from "./DateAPI";

export const api = {
  create : new CreateCalcAPI(),
  update : new UpdateCalcAPI(),
  close : new CloseCalcAPI(),
  mail : new SendMailAPI(),
  code: new VerifyCodeAPI(),
  payment: new PaymentAPI(),
  upload: new DashboardAPI(),
  date: new DateAPI(),
};
